import { c as _c } from "react/compiler-runtime";
import { Provider, type Account } from '@repo/api-gw-sdk';
import { useRestoreAccounts } from '@/app/(dashboard)/settings/restore-accounts/useRestoreAccounts';
import { createCloudProviderCondition } from '@/components/cloudProviders/createCloudProviderCondition';
import { getMrapPolicyJson } from './byovPolicyUtils';
import { Loader } from '../layout/loading';
import { CopyableCode } from '../shared/copyableCode';
export const MrapCopyablePolicy = t0 => {
  const $ = _c(11);
  const {
    mrapAlias,
    vaultAccount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = createCloudProviderCondition([Provider.Aws]);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: restoreAccountsBody,
    isLoading
  } = useRestoreAccounts(t1);
  if (isLoading) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Loader />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== restoreAccountsBody?.accounts) {
    t2 = restoreAccountsBody?.accounts ?? [];
    $[2] = restoreAccountsBody?.accounts;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const restoreAccounts = t2;
  let t3;
  if ($[4] !== mrapAlias || $[5] !== restoreAccounts || $[6] !== vaultAccount) {
    t3 = getMrapPolicyJson(mrapAlias, vaultAccount, restoreAccounts);
    $[4] = mrapAlias;
    $[5] = restoreAccounts;
    $[6] = vaultAccount;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const policy = t3;
  const t4 = !mrapAlias || restoreAccounts.length === 0;
  let t5;
  if ($[8] !== policy || $[9] !== t4) {
    t5 = <CopyableCode title="mrap-policy.json" code={policy} maxHeight="320px" blur={t4} />;
    $[8] = policy;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};